"use client"; // Ensure this directive is present

import React from 'react';

// Data for features
const featuresData = [
    {
        id: 1,
        title: 'Custom Apparel & Uniforms',
        description: 'Professional embroidered and screen-printed apparel including polos, t-shirts, hoodies, jackets, and caps. Perfect for corporate uniforms, team wear, and promotional events.',
        icon: 'fas fa-tshirt',
        link: '/contact',
        delay: '100ms',
    },
    {
        id: 2,
        title: 'Drinkware & Bottles',
        description: 'Custom mugs, tumblers, water bottles, travel cups, and koozies. High-quality drinkware that keeps your brand in customers\' hands daily. Multiple colors and styles available.',
        icon: 'fas fa-mug-hot',
        link: '/contact',
        delay: '200ms',
    },
    {
        id: 3,
        title: 'Office & Business Supplies',
        description: 'Premium pens, notebooks, portfolios, desk accessories, and executive gifts. Professional products that make lasting impressions in any business setting.',
        icon: 'fas fa-pen',
        link: '/contact',
        delay: '300ms',
    },
    {
        id: 4,
        title: 'Tech & Electronics',
        description: 'Power banks, USB drives, phone accessories, wireless chargers, and tech organizers. Modern promotional items for today\'s connected world.',
        icon: 'fas fa-mobile-alt',
        link: '/contact',
        delay: '400ms',
    },
    {
        id: 5,
        title: 'Trade Show & Events',
        description: 'Banners, table covers, tote bags, lanyards, and giveaways. Complete trade show solutions to make your brand stand out at any event or conference.',
        icon: 'fas fa-flag',
        link: '/contact',
        delay: '500ms',
    },
    {
        id: 6,
        title: 'Sports & Recreation',
        description: 'Team uniforms, sports equipment, outdoor gear, and fitness accessories. Perfect for schools, leagues, and corporate wellness programs.',
        icon: 'fas fa-football-ball',
        link: '/contact',
        delay: '600ms',
    },
];

export default function FeatureOne() {
    return (
        <section id="th-services" className="feature-one">
            <div className="container">
                <div className="section-title text-center">
                    <div className="section-title__tagline-box">
                        <span className="section-title__tagline">Our Services</span>
                    </div>
                    <h2 className="section-title__title">Promotional Products That <br /> Make Your Brand Shine</h2>
                </div>
                <div className="row">
                    {featuresData.map((feature) => (
                        <div key={feature.id} className={`col-xl-4 col-lg-6 col-md-6 wow fadeInLeft`} data-wow-delay={feature.delay}>
                            <div className="feature-one__single">
                                <div className="feature-one__icon">
                                    <i className={feature.icon}></i>
                                </div>
                                <div className="feature-one__content">
                                    <h4 className="feature-one__title">{feature.title}</h4>
                                    <p className="feature-one__text">{feature.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
